"use strict";
// Copyright © 2021 Move Closer
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactTabType = void 0;
var ContactTabType;
(function (ContactTabType) {
    ContactTabType["ContactData"] = "contactData";
    ContactTabType["ContactForm"] = "contactForm";
    ContactTabType["Location"] = "location";
})(ContactTabType = exports.ContactTabType || (exports.ContactTabType = {}));
//# sourceMappingURL=Contact.contracts.js.map